import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

import iconUrl from "leaflet/dist/images/marker-icon.png";
import iconShadow from "leaflet/dist/images/marker-shadow.png";

import { motion, useInView } from "framer-motion";
import { useRef } from "react";
import ButtonV2 from "../../shared/components/buttonV2";
import {
  COMMENT_WHITE,
  ENVELOPE_WHITE,
  FRAME_2,
  PHONE_CALL,
  PHONE_WHITE,
  SUBJECT_WHITE,
  USER_WHITE,
} from "../../assets";
// @ts-ignore
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconUrl,
  shadowurl: iconShadow,
});
function Contact() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "0px 0px -100px 0px" });
  return (
    <div
      id="contact"
      className="w-full lg:h-[630px] h-auto min-h-[1100px] relative"
    >
      {/* Map Layer */}
      <img
        src={FRAME_2}
        className="w-full h-full object-cover"
        alt="Background"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-[#00000099] z-10"></div>

      {/* Contact Card and Form */}
      <motion.div
        ref={ref}
        initial={{ opacity: 0, y: 60 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 1, ease: "easeOut" }}
        className="lg:w-[70vw] w-[95vw] mt-8 sm:mt-12 lg:mt-16 absolute bottom-4 sm:bottom-6 lg:bottom-10 z-40 lg:p-16 p-4 sm:p-6 rounded-sm gap-x-5 lg:right-1/4 right-2.5 lg:left-auto left-2.5 lg:space-x-4 space-y-4 shadow-lg flex items-start lg:flex-row flex-col justify-center"
      >
        {/* Contact Info Card */}
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          animate={isInView ? { opacity: 1, x: 0 } : {}}
          transition={{ duration: 1.1, ease: "easeOut", delay: 0.3 }}
          className="h-full w-full lg:min-w-[342px] rounded-lg bg-white p-2"
        >
          <div className="w-full h-full p-4 sm:p-5 flex flex-col gap-y-4 sm:gap-y-5 bg-globalGreen">
            <div className="flex flex-col gap-y-2 sm:gap-y-3 items-start text-white">
              <span className="text-[14px] sm:text-[16px] font-bold">
                Our Location
              </span>
              <span className="text-xs sm:text-sm font-medium leading-relaxed">
                Judiciary Complex, Independence Layout, Enugu, Nigeria
              </span>
            </div>

            <div className="flex flex-col gap-y-2 sm:gap-y-3 items-start text-white">
              <span className="text-[14px] sm:text-[16px] font-bold">
                Quick Contact
              </span>
              <span className="text-xs sm:text-sm font-medium">
                Email: support@lispensens.en.gov.ng
              </span>
              <span className="text-xs sm:text-sm font-medium">
                Support: registry@lispensens.en.gov.ng
              </span>
            </div>

            <span className="text-xs sm:text-sm text-white font-medium leading-relaxed">
              We will respond within 24 hours, or call us during weekdays, 09:00
              AM – 05:00 PM
            </span>

            <div className="flex items-center gap-x-3 text-white">
              <img
                src={PHONE_CALL}
                className="w-[24px] sm:w-[30px] h-[24px] sm:h-[30px]"
                alt="Call Icon"
              />
              <span className="text-[14px] sm:text-[16px] font-bold">
                {" "}
                +234 809 4906 0890
              </span>
            </div>
          </div>
        </motion.div>

        {/* Contact Form */}
        <div className="w-full lg:w-[90vw] h-full flex flex-col items-start gap-y-4 sm:gap-y-5">
          <span className="font-bold text-xl sm:text-2xl text-white">
            Send a message
          </span>
          <span className="text-xs sm:text-sm text-white font-medium leading-relaxed">
            We're here to assist you with inquiries regarding appeals, court
            procedures, and other matters under the jurisdiction of the Enugu
            State Customary Court of Appeal. Please fill out the form below and
            we will respond promptly.
          </span>

          <div className="flex flex-col items-start gap-y-3 w-full">
            <span className="text-xs sm:text-sm font-semibold text-white">
              Personal Details
            </span>
            <div className="w-full flex flex-col lg:flex-row gap-3 sm:gap-5">
              <div className="flex items-center border border-[#E9EAEB] w-full">
                <div className="w-[40px] sm:w-[48px] h-[40px] sm:h-[48px] p-2 sm:p-3 rounded-md flex items-center justify-center bg-globalGreen">
                  <img
                    src={USER_WHITE}
                    alt="User Icon"
                    className="w-4 sm:w-5 h-4 sm:h-5"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Name (Your Full Name)"
                  className="outline-none text-xs sm:text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-2 sm:p-3 w-full"
                />
              </div>
              <div className="flex items-center border border-[#E9EAEB] w-full">
                <div className="w-[40px] sm:w-[48px] h-[40px] sm:h-[48px] p-2 sm:p-3 rounded-md flex items-center justify-center bg-globalGreen">
                  <img
                    src={ENVELOPE_WHITE}
                    alt="Email Icon"
                    className="w-4 sm:w-5 h-4 sm:h-5"
                  />
                </div>
                <input
                  type="email"
                  placeholder="Email Address"
                  className="outline-none text-xs sm:text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-2 sm:p-3 w-full"
                />
              </div>
            </div>
            <div className="w-full flex flex-col lg:flex-row gap-3 sm:gap-5">
              <div className="flex items-center border border-[#E9EAEB] w-full">
                <div className="w-[40px] sm:w-[48px] h-[40px] sm:h-[48px] p-2 sm:p-3 rounded-md flex items-center justify-center bg-globalGreen">
                  <img
                    src={PHONE_WHITE}
                    alt="Phone Icon"
                    className="w-4 sm:w-5 h-4 sm:h-5"
                  />
                </div>
                <input
                  type="tel"
                  placeholder="Phone Number"
                  className="outline-none text-xs sm:text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-2 sm:p-3 w-full"
                />
              </div>
              <div className="flex items-center border border-[#E9EAEB] w-full">
                <div className="w-[40px] sm:w-[48px] h-[40px] sm:h-[48px] p-2 sm:p-3 rounded-md flex items-center justify-center bg-globalGreen">
                  <img
                    src={SUBJECT_WHITE}
                    alt="Subject Icon"
                    className="w-4 sm:w-5 h-4 sm:h-5"
                  />
                </div>
                <input
                  type="text"
                  placeholder="Subject"
                  className="outline-none text-xs sm:text-sm placeholder:text-[#808080] border border-[#E9EAEB] p-2 sm:p-3 w-full"
                />
              </div>
            </div>
            <div className="flex items-start border bg-white border-[#E9EAEB] p-0 w-full">
              <div className="w-[40px] sm:w-[48px] h-[40px] sm:h-[48px] p-2 sm:p-3 flex items-center justify-center bg-globalGreen">
                <img
                  src={COMMENT_WHITE}
                  alt="Comment Icon"
                  className="w-4 sm:w-5 h-4 sm:h-5"
                />
              </div>
              <textarea
                rows={4}
                placeholder="Message here"
                className="outline-none resize-none text-xs sm:text-sm placeholder:text-[#808080] p-2 sm:p-3 w-full min-w-0"
              />
            </div>
          </div>

          <ButtonV2
            title="Send Message"
            handleClick={() => {}}
            btnStyle="px-6 sm:px-8 py-2 sm:py-3 bg-globalGreen w-fit flex self-end rounded-full"
            textStyle="text-white font-medium text-[14px] sm:text-[16px]"
          />
        </div>
      </motion.div>
    </div>
  );
}

export default Contact;
